// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".live-chat[data-v-427c901d]{background:#fff;transition:height 10ms}@media only screen and (min-width:1264px){.live-chat[data-v-427c901d]{max-width:450px;min-width:450px}.live-chat .chat[data-v-427c901d]{min-height:0;overflow:hidden}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
